/* eslint-disable no-empty-pattern */
/* eslint-disable array-bracket-newline */
/**
 * Implements a page footer bar
 */
import watchlist from '../../../assets/images/watchlist_down.svg';
import swap from '../../../assets/images/swap_grey.svg';
import { MobileState } from '.';
import MobileWallet from './MobileWallet';
import NavItem from './NavItem';
import './styles.scss';

interface IFooterProps {
  selected: MobileState;
  onChange: (target: MobileState) => void;
}


const FooterMobile = ({ selected, onChange }: IFooterProps) => (
  <div className='global_footer_mobile'>
    <NavItem
      onClick={() => onChange(MobileState.Watchlist)}
      icon={watchlist}
      active={selected === MobileState.Watchlist}
      title='Watchlist'
    />
    <NavItem
      onClick={() => onChange(MobileState.Trading)}
      icon={swap}
      active={selected === MobileState.Trading}
      title='Swap'
    />
    <MobileWallet />
  </div>
);

export default FooterMobile;
